import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FooterPagesNavigation from "../../../components/FooterPagesNavigation";
import { methodGet, methodPost, waitForSeconds } from "../../../helper";
import { checkIfAllowedToRespond, findNotResponded, isAllResponded, onCompleted } from "../formHelper";
import info from "../../../data/drivers.json";

export default function QuestionsDrivers({}) {
  const navigate = useNavigate();
  const [reponses, setReponses] = useState(
    localStorage.getItem("reponses")
      ? JSON.parse(localStorage.getItem("reponses"))
      : [
          ...info.questions.map((q, group) =>
            q.map((e, key) => {
              return {
                group: group,
                number: key,
                scoreGroup: e.group,
                score: undefined,
              };
            })
          ),
        ]
  );
  const [page, setPage] = useState(1);
  const hash = useLocation().hash;

  useEffect(() => {
    checkIfAllowedToRespond(0)
      .then()
      .catch((err) => navigate("/notAllowed"));
  }, []);

  useEffect(() => {
    setPage(parseInt(hash.split("#")[1]));
    window.scrollTo({ top: 0 });
  }, [hash]);

  useEffect(() => {
    displayCards();
    return () => {
      for (let index = 0; index < 5; index++) {
        if (document.getElementById("card_" + page + "_" + index)) {
          document.getElementById("card_" + page + "_" + index).classList.add("opacity-0");
          document.getElementById("card_" + page + "_" + index).classList.remove("mt-5");
        }
      }
    };
  }, [page]);

  async function displayCards() {
    await waitForSeconds(0.1);
    for (let index = 0; index < 5; index++) {
      if (document.getElementById("card_" + page + "_" + index)) {
        document.getElementById("card_" + page + "_" + index).classList.remove("opacity-0");
        document.getElementById("card_" + page + "_" + index).classList.add("mt-5");
        await waitForSeconds(0.1);
      }
    }
  }

  return (
    <>
      <div className="flex flex-col items-center p-4 mb-36">
        <div className="flex flex-col md:grid md:grid-cols-2 md:gap-4">
          <img id="logo_cards" src={"/images/" + info.images[page - 1]} className="mx-auto h-64 transition-all duration-1000 ease-out mt-5" alt="logo" />
          {info.questions[page - 1].map((question, key) => (
            <div
              key={question.message}
              id={"card_" + page + "_" + key}
              className="flex flex-col max-w-lg p-4 bg-white w-full shadow-xl opacity-0 transition-all duration-500 ease-out rounded-lg"
            >
              <p className="font-bold">Cas n°{key + 1}</p>
              <hr className="mb-4" />
              <p className="text-lg flex-grow">{question.message}</p>
              <p className={"text-center mt-8 mb-3 text-sm " + (info.reponsesPosibles[reponses[page - 1][key].score - 1] ? "" : "text-red-400")}>
                {info.reponsesPosibles[reponses[page - 1][key].score - 1] ? info.reponsesPosibles[reponses[page - 1][key].score - 1] : "Pas de réponse"}
              </p>
              <div className="flex items-center w-full text-white font-bold">
                {info.reponsesPosibles.map((res, k) => (
                  <>
                    {k !== 0 && (
                      <div
                        key={"divisor_" + page + "_" + key + "_" + k}
                        onClick={() => {
                          let modif = [...reponses];
                          modif[page - 1][key].score = k + 1;
                          setReponses(modif);
                        }}
                        className={
                          "flex-grow h-2  hover:ring-1 hover:ring-palette-green hover:ring-opacity-50 " +
                          (reponses[page - 1][key].score > k ? "bg-palette-green" : "bg-palette-light-green")
                        }
                      />
                    )}
                    <div
                      key={"element_" + page + "_" + key + "_" + k}
                      className={
                        "rounded-full hover:ring-2 hover:ring-palette-green hover:ring-opacity-50 cursor-pointer text-sm w-8 h-8 flex items-center justify-center " +
                        (reponses[page - 1][key].score > k ? "bg-palette-green" : "bg-palette-light-green")
                      }
                      onClick={() => {
                        let modif = [...reponses];
                        modif[page - 1][key].score = k + 1;
                        setReponses(modif);
                      }}
                    >
                      {(k + 1).toString()}
                    </div>
                  </>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <FooterPagesNavigation
        pages={5}
        onEnd={() => onCompleted(reponses, navigate)}
        endDisable={!isAllResponded(reponses)}
        onClickDisable={() => findNotResponded(reponses, navigate)}
        textDisable="Réponses manquantes"
      />
    </>
  );
}
